<template>
  <div class="mainWrapper">
     <!-- <ParentTabComponent v-if="showParentTabComponent"/> -->
    <router-view />
  </div>
</template>

<script>
import './assets/css/stylesheet.css'
import './assets/css/luckyNumber.css'
// import DefaultComponent from './components/DefaultComponent.vue'

import { computed } from 'vue';
import { useRoute } from 'vue-router';
export default {
  name: 'App',
  components: {
    // DefaultComponent
  },
  setup() {
    const route = useRoute();
    const showParentTabComponent = computed(() => {
      return !route.path.startsWith('/Mylevel');
    });

    return {
      showParentTabComponent
    };
  },

  watch: {
    $route(to) {
      if (to.path.includes("fans_ranking")) {
        document.body.classList.add("fansRanking-page");
      } else {
        document.body.classList.remove("fansRanking-page");
      }
    },
  },
  mounted() {
    // Also run once on initial load
    if (this.$route.path.includes("fans_ranking")) {
      document.body.classList.add("fansRanking-page");
    }
  },
}
</script>
<style>
  /* The Mulish @import used to live here. An @import inside a bundled
     stylesheet is only discovered once that stylesheet has downloaded and
     parsed, so the font request could not start until app.css was done -
     about 580ms late - and it blocks the first paint behind it. It is a
     <link> in public/index.html now, so it loads alongside the other CSS. */
  body {font-family: "Mulish", sans-serif;}
</style>
